import { Flow_0_0_2, getFullItemOne } from '@flexus/core';
import { skipWhile, take, map } from 'rxjs/operators';
import { BET_97 } from './BET_97';
import { UntypedFormControl } from '@angular/forms';

export const BET_106: Flow_0_0_2 = {
	id: '106',
	name: 'assessor_on_site',
	itemType: 'flow',
	fetchLevel1And2: BET_97.fetchLevel1And2,
	header: {
		title: (store, bf) => {
			bf.bigForm.addControl('workflow_current_state', new UntypedFormControl(106));
			return store.select(getFullItemOne).pipe(
				skipWhile(res => !res),
				take(1),
				map(itemOne => {
					if (itemOne) {
						let title = 'Assessor on Site';
						if (itemOne?.loan_information?.mavenclaimnumber) {
							title += ` : ${itemOne?.loan_information?.mavenclaimnumber}`;
						}
						if (itemOne.applicant?.surname) {
							title += ` - ${itemOne.applicant?.surname}`;
						}

						return title;
					} else {
						return 'Assessor on Site';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		...BET_97.footer
	},
	instructions: {
		...BET_97.instructions
	},
	actionPanel: BET_97.actionPanel,
	serverCalls: {
		...BET_97.serverCalls
	},
	startNode: 'JobSummary',
	nodes: {
		...BET_97.nodes
	},
	bigFormToStoreMapper: {
		...BET_97.bigFormToStoreMapper
	}
};
